module.exports = __webpack_public_path__ + "static/media/Circo2025_09.8eae2e0b.webp";